import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  whiteColor: {
    color: theme.palette.common.white,
    fontSize: 34,
    lineHeight: 1.3,
    fontWeight: 'bold',
  },
  carouselRoot: {
    marginTop: theme.spacing(4),
    padding: 0,
  },
  carousel: {
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 14),
    },

    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 50),
    },

    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 55),
    },
  },
  carouselItem: {
    textAlign: 'center',
    padding: theme.spacing(0, 2),

    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 1),
    },
  },
}));
